import { render, staticRenderFns } from "./InsurancePrice.vue?vue&type=template&id=a2cb9718&scoped=true&"
import script from "./InsurancePrice.vue?vue&type=script&lang=js&"
export * from "./InsurancePrice.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePrice.vue?vue&type=style&index=0&id=a2cb9718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cb9718",
  null
  
)

export default component.exports